import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface ErrorProps extends RouteComponentProps {
  image: React.ReactElement;
  message: string;
}

const ErrorPage: React.FunctionComponent<ErrorProps> = ({
  image: Image,
  message,
  history,
  ...restProps
}) => {
  return (
    // <div className="error-container" {...restProps}>
    <div className="signin-container" {...restProps}>
      {Image}
      <div className="error-message-container">{message}</div>
      <button
        style={{backgroundColor: '#E5B611', width: '297px', height: '32px', display: 'flex', justifyContent: 'center', alignItems: 'center', border: 'black'}}
        // className="error-home-button"
        onClick={() => {
          history.push("/associated-chains");
        }}
      >
        Go Home
      </button>
    </div>
  );
};

export default withRouter(ErrorPage);
